module.exports = __webpack_public_path__ + "img/cart-with-box-outline-blue.d4cf56f6.svg";